import { assetCodesByAssetClass } from "@domains/mapper/Reports/AssetsAndProducts";
import { checkValue, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
export const dashboardHoldingMapper = (data) => {
    if (data) {
        const holdingDashboardSummary = data.holdingDashboardSummary.map((x) => {
            return {
                assetClass: x.assetClass,
                investmentValue: String(checkValue(x.investmentValue)),
                marketValue: String(checkValue(x.marketValue)),
                pnl: String(checkValue(x.pnl)),
                pnlPercent: String(checkValue(x.pnlPercent)),
                totalHoldingPrc: String(checkValue(x.totalHoldingPrc)),
                assetCode: assetCodesByAssetClass.get(x.assetClass.toLowerCase()),
            };
        });
        const holdingDetail = data.holdingDetail.map((x) => {
            return {
                scripName: x.scripName,
                quantity: x.quantity,
                longTermQuantity: x.longTermQuantity,
                averagePrice: x.averagePrice,
                investmentValue: x.investmentValue,
                currentValue: x.currentValue,
                pnl: x.pnl,
                pnlChangePercentage: x.pnlChangePercentage,
                dayChange: x.dayChange,
                freeQuantity: x.freeQuantity,
                normalMarginPledge: x.normalMarginPledge,
                lockedInQuantity: x.lockedInQuantity,
                cusa: x.cusa,
                mtfPledge: x.mtfPledge,
                t1: x.t1,
                t1Mtf: x.t1Mtf,
                lasPledge: x.lasPledge,
                sebiMtfHoldQuantity: x.sebiMtfHoldQuantity,
                safeKeepQuantity: x.safeKeepQuantity,
                soldQuantity: x.soldQuantity,
                tradableQuantity: x.tradableQuantity,
                previousClosingValue: x.previousClosingValue,
                quote: Object.assign(Object.assign({}, x.quote), { assetCode: x.quote.assetCode
                        ? x.quote.assetCode
                        : assetCodesByAssetClass.get(x.edelweissAssetClass.toLowerCase()) }),
                filterFlags: x.filterFlags,
                earMarkedQuantity: x.earMarkedQuantity,
                thirdPartyPledge: x.thirdPartyPledge,
                sector: x.sector,
                corpAction: x.corpAction,
                corpActionType: x.corpActionType,
                corpActionDesc: x.corpActionDesc,
                edelweissProduct: x.edelweissProduct,
                edelweissAssetClass: x.edelweissAssetClass,
                displayName: x.quote.displayName,
                changePercentage: roundUpToTwoDecimalPlaces(Number(x.quote.changePercentage)),
                scripIdentifier: x.scripIdentifier,
                rating: x.rating,
                ratingAgent: x.ratingAgent,
                insuranceCategory: x.insuranceCategory,
                folioNumber: x.folioNumber,
                physical: x.physical
            };
        });
        return Object.assign(Object.assign({}, data), { holdingDetail: holdingDetail, holdingDashboardSummary: holdingDashboardSummary, isOmneOnly: !!(data === null || data === void 0 ? void 0 : data.isOmneOnly), isBodEnabled: data === null || data === void 0 ? void 0 : data.isBodEnabled, bodProcessInfoMessage: data === null || data === void 0 ? void 0 : data.bodProcessInfoMessage });
    }
    else {
        return null;
    }
};
